import axiosClient from '../../../config/axios-client'

const CountryService = {
  getCountry(countryId) {
    return axiosClient.get(`/dashboard/countries/${countryId}`)
  },
  getCountries() {
    return axiosClient.get('/dashboard/countries')
  },
}

export default CountryService
